import React from "react";

export default function ConfirmModal({
  isOpen,
  title = "Are you sure?",
  message = "",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onCancel,
  onConfirm,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
        {message && <p className="mb-6 text-gray-700">{message}</p>}
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="cancel-btn"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="btn-danger"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
